import React from 'react';
import { useTranslation } from '../../../../contexts/I18nProvider';

export interface OverReceiveConfirmModalProps {
    isOpen: boolean;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const OverReceiveConfirmModal: React.FC<OverReceiveConfirmModalProps> = ({
    isOpen,
    message,
    onConfirm,
    onCancel
}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                {/* Header */}
                <div className="bg-yellow-500 text-white px-6 py-4 rounded-t-lg">
                    <div className="flex items-center">
                        <svg className="h-6 w-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <h3 className="text-lg font-semibold">{t('warehouse.modules.receipt.warnings.overReceiveTitle')}</h3>
                    </div>
                </div>

                {/* Body */}
                <div className="px-6 py-4">
                    <p className="text-gray-700 whitespace-pre-line">{message}</p>
                </div>

                {/* Footer with buttons */}
                <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors font-medium"
                    >
                        {t('common.buttons.cancel')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors font-medium"
                    >
                        {t('warehouse.modules.receipt.overReceive.continue')}
                    </button>
                </div>
            </div>
        </div>
    );
};
